import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import { FormattedMessage, FormattedNumber } from 'js/lib/coursera.react-intl';
import user from 'js/lib/user';

import { CML } from 'bundles/cml';
import { fetchAnswers } from 'bundles/discussions/actions/ThreadDetailsActions';
import {
  Completed,
  Input,
  RespondedLearnersImage,
  Saving,
} from 'bundles/discussions/components/discussionPrompt/DiscussionPromptComponents';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import RepliesList from 'bundles/discussions/components/repliesList/RepliesList';
import { answerSorts } from 'bundles/discussions/constants';
import Icon from 'bundles/iconfont/Icon';

/* @ts-expect-error ts-migrate(7016) FIXME: Untyped import */
import OnDemandCourseForumsV1 from 'bundles/naptimejs/resources/onDemandCourseForums.v1';
import { savingStates } from 'bundles/profile/constants/constants';

import _t from 'i18n!nls/discussions';

import 'css!./__styles__/DiscussionPrompt';

class DiscussionPrompt extends React.Component {
  static propTypes = {
    savingStates: PropTypes.object.isRequired,
    previouslyCompleted: PropTypes.bool.isRequired,
    page: PropTypes.number,
    answerId: PropTypes.string,
    courseId: PropTypes.string,
    courseSlug: PropTypes.string,
    currentForum: PropTypes.instanceOf(OnDemandCourseForumsV1),
    currentForumUrl: PropTypes.string,
    questionId: PropTypes.string,
    question: PropTypes.object,
    promptContent: PropTypes.object,
    learnerCount: PropTypes.number,
    isLoaded: PropTypes.bool,
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof DiscussionPrompt.contextTypes>;

  constructor(props: $TSFixMe, context: $TSFixMe) {
    super(props, context);

    this.state = {
      savingState: savingStates.UNCHANGED,
      forumError: false,
    };
  }

  componentDidMount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isLoaded' does not exist on type 'Readon... Remove this comment to see the full error message
    if (this.props.isLoaded) {
      this.setState({
        // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
        questionId: this.props.questionId,
      });
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
      this.fetchAnswers(this.props.questionId, answerSorts.newestSort, this.props.page);
    }
  }

  componentWillReceiveProps(nextProps: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
    const { questionId } = this.state;
    this.setState({
      savingState: nextProps.savingStates[questionId] || savingStates.UNCHANGED,
    });

    if (
      questionId &&
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'savingStates' does not exist on type 'Re... Remove this comment to see the full error message
      this.props.savingStates[questionId] === savingStates.SAVING &&
      nextProps.savingStates[questionId] === savingStates.SAVED
    ) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'page' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      this.fetchAnswers(questionId, answerSorts.newestSort, this.props.page);
    }
  }

  componentDidUpdate(oldProps: $TSFixMe, oldState: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
    const { questionId, page } = this.props;
    if (oldProps.page !== page) {
      this.fetchAnswers(questionId, answerSorts.newestSort, page);
    }
  }

  fetchAnswers(questionId: $TSFixMe, sort: $TSFixMe, page: $TSFixMe) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'courseId' does not exist on type 'Readon... Remove this comment to see the full error message
    const { courseId, courseSlug, currentForum } = this.props;
    const { executeAction } = this.context;

    executeAction(fetchAnswers, {
      questionId,
      courseId,
      courseSlug,
      sort,
      page,
      contextId: courseId,
      userId: user.get().id,
      forumType: currentForum.forumType.typeName,
    });
  }

  renderLoading() {
    return (
      <div className="vertical-box align-items-vertical-center">
        <Icon name="spinner" className="cif-spin cif-3x" />
      </div>
    );
  }

  renderInput() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'learnerCount' does not exist on type 'Re... Remove this comment to see the full error message
    const { learnerCount, question, questionId, page } = this.props;
    const hasRespondedLearners = learnerCount > 0;

    return (
      <div>
        <div className="color-hint-text participation-text">{_t('Participation is optional')}</div>
        <Input
          // @ts-expect-error ts-migrate(2339) FIXME: Property 'savingState' does not exist on type 'Rea... Remove this comment to see the full error message
          savingState={this.state.savingState}
          question={question}
          placeholder={_t('Type your response here...')}
        />
        <RespondedLearnersImage responseCount={learnerCount} questionId={questionId} page={page} />
        <div
          className="horizontal-box align-items-absolute-center caption-text color-secondary-text"
          aria-labelledby="submissions-made-count-message"
        >
          {hasRespondedLearners ? (
            <div id="submissions-made-count-message">
              <FormattedNumber value={learnerCount} />
              &nbsp;
              <FormattedMessage
                message={_t('{learnerCount, plural, =1 { learner has} other { learners have}} submitted a response.')}
                learnerCount={learnerCount}
              />
            </div>
          ) : (
            <div id="submissions-made-count-message">{_t('Be the first to submit a response')}</div>
          )}
        </div>
      </div>
    );
  }

  renderError() {
    return (
      <div className="horizontal-box align-items-absolute-center bgcolor-white c-prompt-card">
        <span className="caption-text color-secondary-text">{_t('Sorry, we were unable to retrieve a forum.')}</span>
      </div>
    );
  }

  renderCompleted() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'questionId' does not exist on type 'Read... Remove this comment to see the full error message
    const { questionId, previouslyCompleted, page, currentForum, answerId, currentForumUrl, courseId } = this.props;

    return (
      <div>
        <Completed showLink={previouslyCompleted} questionId={questionId} userId={user.get().id} courseId={courseId} />
        <div className="c-thread-container">
          <RepliesList
            // @ts-expect-error ts-migrate(2322) FIXME: Type '{ sort: string; page: any; forumId: any; que... Remove this comment to see the full error message
            sort={answerSorts.newestSort}
            page={page}
            forumId={currentForum.id}
            questionId={questionId}
            answerId={answerId}
            forumLink={currentForumUrl}
          />
        </div>
      </div>
    );
  }

  renderContent() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'savingState' does not exist on type 'Rea... Remove this comment to see the full error message
    const { savingState } = this.state;

    // @ts-expect-error ts-migrate(2339) FIXME: Property 'previouslyCompleted' does not exist on t... Remove this comment to see the full error message
    if (savingState === savingStates.SAVED || this.props.previouslyCompleted) {
      return this.renderCompleted();
    } else if (
      savingState === savingStates.UNCHANGED ||
      savingState === savingStates.ERROR ||
      savingState === savingStates.INVALID_TERM_ERROR ||
      savingStates.RATE_LIMIT_ERROR ||
      savingStates.USER_BLOCKED_ERROR
    ) {
      return this.renderInput();
    } else if (savingState === savingStates.SAVING) {
      return <Saving />;
    }

    return false;
  }

  renderBody() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'promptContent' does not exist on type 'R... Remove this comment to see the full error message
    const { promptContent } = this.props;

    return (
      <div>
        <span>
          <CML cml={promptContent} />
        </span>
        {this.renderContent()}
      </div>
    );
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isLoaded' does not exist on type 'Readon... Remove this comment to see the full error message
    const { isLoaded } = this.props;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'forumError' does not exist on type 'Read... Remove this comment to see the full error message
    const { forumError } = this.state;
    return (
      <div className="rc-DiscussionPrompt">
        {!forumError && (isLoaded ? this.renderBody() : this.renderLoading())}
        {forumError && this.renderError()}
      </div>
    );
  }
}

export default DiscussionPrompt;
